import styled from 'src/styles/theme';
import CarNumberTemplate from './CarNumberTemplate';

export const CarNumberStyled = styled(CarNumberTemplate)``;
